/* Header disclosures.
 *
 * The nav, the search panel and the drawer are all native <details>, so they
 * open and close with JavaScript switched off. Everything here is polish on
 * top: close on Escape, close when you click away, keep only one panel open,
 * and stop the page behind the drawer from scrolling.
 *
 * The search forms are also wrapped in <predictive-search>, which brings its
 * own idea of open and closed. The two have to be introduced to each other or
 * they fight: Escape would rip the whole panel away the moment you dismissed a
 * dropdown, and reopening the panel would flash yesterday's suggestions back
 * up. The helpers below are the introduction.
 */
(function () {
  var disclosures = function () {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cp-disclosure]'));
  };

  var lockScroll = function () {
    var drawerOpen = document.querySelector('.cp-drawer[open]');
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
  };

  /* predictive-search.js defines close() on the custom element. If the script
   * has not upgraded the element yet — or predictive search is switched off in
   * the theme settings, in which case it is a <search-form> instead — there is
   * nothing to close and nothing to do. */
  var OPEN_SUGGESTIONS = 'predictive-search[open], predictive-search[loading]';

  var closeSuggestions = function (root) {
    if (!root || !root.querySelectorAll) return false;

    // querySelectorAll only looks at descendants, and root is sometimes the
    // <predictive-search> element itself, so it has to be checked separately.
    var found = Array.prototype.slice.call(root.querySelectorAll(OPEN_SUGGESTIONS));
    if (root.matches && root.matches(OPEN_SUGGESTIONS)) found.push(root);

    var closed = false;
    found.forEach(function (search) {
      if (typeof search.close === 'function') {
        search.close();
        closed = true;
      }
    });
    return closed;
  };

  /* Only the desktop panel. Opening the drawer on a phone and having the
   * keyboard shoot up over the menu you just asked to see is not helpful. */
  var focusSearch = function (details) {
    if (!details.classList || !details.classList.contains('cp-search')) return;
    var input = details.querySelector('input[type="search"]');
    if (input) input.focus();
  };

  var closeAll = function (except) {
    disclosures().forEach(function (details) {
      if (details !== except && !details.contains(except) && details.open) {
        details.open = false;
        closeSuggestions(details);
      }
    });
    lockScroll();
  };

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.hasAttribute || !details.hasAttribute('data-cp-disclosure')) return;
    if (details.open) {
      closeAll(details);
      focusSearch(details);
    } else {
      // Hidden suggestions are still open suggestions as far as the custom
      // element is concerned, and they would reappear next time the panel does.
      closeSuggestions(details);
    }
    lockScroll();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    // First Escape puts the suggestions away and leaves you in the box you
    // were typing in. Second Escape closes the panel.
    var active = document.activeElement;
    if (active && active.closest && closeSuggestions(active.closest('predictive-search'))) return;

    var open = document.querySelector('[data-cp-disclosure][open]');
    if (!open) return;
    var summary = open.querySelector('summary');
    open.open = false;
    closeSuggestions(open);
    lockScroll();
    if (summary) summary.focus();
  });

  document.addEventListener('click', function (event) {
    // The scrim sits inside the drawer, so treat it as an explicit close.
    if (event.target.classList && event.target.classList.contains('cp-drawer__scrim')) {
      closeAll(null);
      return;
    }
    if (event.target.closest('[data-cp-disclosure]')) return;
    closeAll(null);
  });
})();
